import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints.styles';

export const AdSenseContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 120rem;
  margin: 0 auto;
  padding: 2.4rem 4rem;
  min-height: 9rem;
  overflow: hidden;

  ins.adsbygoogle {
    width: 100%;
  }

  @media ${breakpoints.mobile} {
    padding: 1.6rem 2rem;
    min-height: 8rem;
  }
`;
